
// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiNumberInput from './vendors/farlo-ui-numberinput.js';
import FarloUiList from './vendors/farlo-ui-list.js';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import FarloUiTicketCalendar from './vendors/farlo-ui-ticket-calendar';
import addLightboxToGallery from './vendors/farlo-ui-gallery-lightbox.js';

// Import Footer Components
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
// import { crmSignup } from './components/footer/crm.js';
import { elementInView } from './components/footer/elementInView.js';
import { toggleFAQ } from './components/footer/toggleFAQ.js';
import { faqs } from './components/footer/faqs.js';
import { navigation, navicon } from './components/footer/navigation.js';
import { navigationSecond, naviconSecond } from './components/footer/navigationSecond.js';
import { smoothScrollToAnchor } from './components/footer/smoothScrollToAnchor.js';
import { embedOverlay } from './components/footer/embedOverlay.js';
import { mapLoader } from './components/footer/mapLoader.js';
import { farloUiMasthead } from './components/footer/flickity-masthead.js';
import { stickyColumn } from './components/footer/sticky.js';
import { farloUiPodcastSlider } from './components/footer/flickity-shows.js';

((document, window, history) => {
	const pushState = history.pushState;

	history.pushState = function (state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__group')) {
			navicon();
		}

		if (document.querySelector('.sticky-container')) {
			window.addEventListener('load', () => {
				stickyColumn();

				// setTimeout(() => {
				// 	stickyColumn();
				// }, 100);
			});
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.site-navigation-second__group')) {
			naviconSecond();
		}

		if (document.querySelector('.site-navigation-second__sub-menu')) {
			document.querySelectorAll('.site-navigation-second__sub-menu').forEach((_sel) => {
				navigationSecond(_sel);
			});
		}

		if (document.querySelector('.masthead-slider__flickity')) {
			document.querySelectorAll('.masthead-slider__flickity').forEach((_sel) => {
				farloUiMasthead(_sel);
			});
		}

		if (document.querySelector('.cards-slider__enable')) {
			document.querySelectorAll('.cards-slider__enable').forEach((_sel) => {
				farloUiPodcastSlider(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		// if (document.querySelector('.farlo-ui-crm--i')) {
		// 	document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
		// 		crmSignup(_sel);
		// 	});
		// }

		if (document.querySelector('.is-style-lightbox-gallery')) {
			addLightboxToGallery();
		}

		if (document.querySelectorAll('.wp-block-embed')) {
			embedOverlay();
		}

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			const buttons = document.querySelectorAll('.farlo-ui-crm__toggle');
			const crmBlocks = document.querySelectorAll('.farlo-ui-crm[farlo-ui="crm"]');

			buttons.forEach(function (button) {
				let closestCrmBlock = null;
				let closestDistance = Infinity;

				crmBlocks.forEach(function (block) {
					const distance = button.getBoundingClientRect().top - block.getBoundingClientRect().top;
					if (distance > 0 && distance < closestDistance) {
						closestDistance = distance;
						closestCrmBlock = block;
					}
				});

				if (closestCrmBlock) {
					const crmId = closestCrmBlock.getAttribute('data-crm-id');
					button.setAttribute('data-crm-button-for', crmId);
				}
			});

			buttons.forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}

		if (document.querySelector('.farlo-ui-map')) {
			mapLoader();
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScrollToAnchor(_sel);
		});

		if (document.querySelector('.rank-math-list-item')) {
			document.querySelectorAll('.rank-math-question').forEach((_el) => {
				_el.dataset.toggled = '0';
				_el.addEventListener('click', () => {
					toggleFAQ(_el);
				});
			});
		}

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				new FarloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}
		if (document.querySelector('input[type="number"]')) {
			document.querySelectorAll('input[type="number"]').forEach((numberInput) => {
				new FarloUiNumberInput(numberInput);
			});
		}

		if (document.querySelector('.gfield_list_icons')) {
			document.querySelectorAll('.gfield_list_icons').forEach(function (buttonContainer) {
				new FarloUiList(buttonContainer);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				new FarloUiRevolverCarousel(_sel);
			});
		}

		if (document.querySelector('.site-archive-production')) {
			showListings();
		}

	});

	function showListings() {
		// const listing = document.querySelector('.site-archive-production-list');

		// let currentPage = 1;



		// function fetchArtists(page = 1, event = null) {
		// 	currentPage = page;

		// 	// Detect if the function is triggered by the "Load More" button
		// 	if (event?.target?.classList.contains('site-archive-production__load-more')) {
		// 		event.target.setAttribute('disabled', true); // Disable button during loading
		// 	}

		// 	const data = new URLSearchParams();
		// 	data.append('action', 'farloProductionFilter');
		// 	data.append('nonce', farloAjaxHandler.nonce);
		// 	data.append('page', currentPage);

		// 	listing.classList.add('site-archive-production-list--loading');

		// 	fetch(farloAjaxHandler.ajaxurl, {
		// 		method: 'POST',
		// 		body: JSON.stringify(data), // Send as JSON
		// 		headers: {
		// 			'Accept': 'application/json',
		// 			'Content-Type': 'application/x-www-form-urlencoded',
		// 			'X-WP-Nonce': farloAjaxHandler.nonce
		// 		}
		// 	})


		// 		.then(response => {
		// 			if (!response.ok) {
		// 				throw new Error(`HTTP error! Status: ${response.status}`);
		// 			}
		// 			return response.json();
		// 		})
		// 		.then(response => response.json())
		// 		.then(data => {
		// 			if (data && data.html) {
		// 				listing.insertAdjacentHTML('beforeend', data.html); // Append new posts

		// 				// If there are no more posts, remove the "Load More" button
		// 				if (!data.has_more) {
		// 					event.target.remove();
		// 				} else {
		// 					event.target.removeAttribute('disabled'); // Re-enable button
		// 					currentPage++;
		// 				}
		// 			}
		// 		})
		// 		.catch(error => {
		// 			console.error('Fetch error:', error);
		// 			event?.target?.removeAttribute('disabled'); // Re-enable button on error
		// 		})
		// 		.finally(() => {
		// 			listing.classList.remove('site-archive-production-list--loading');
		// 		});
		// }

		// if (document.querySelector('.site-archive-production__load-more')) {
		// 	document.querySelector('.site-archive-production__load-more').addEventListener('click', (e) => {
		// 		fetchArtists(currentPage + 1, false, e);
		// 	});
		// }

		// Get the load more button by its ID (ensure your button has id="load-more-productions")
		const loadMoreButton = document.getElementById("load-more-productions");
		let currentPage = parseInt(my_ajax_object.current_page); // Start page (should be 1)
		const maxPages = parseInt(my_ajax_object.max_pages); // Maximum pages (set in PHP)

		loadMoreButton.addEventListener("click", function (event) {
			event.preventDefault();
			currentPage++;

			// If we've reached the maximum page count, hide the button
			if (currentPage > maxPages) {
				loadMoreButton.style.display = "none";
				return;
			}

			// Prepare the data to send via AJAX
			const formData = new FormData();
			formData.append("action", "load_more_productions");
			formData.append("page", currentPage);

			// Make the AJAX request using fetch
			fetch(my_ajax_object.ajax_url, {
				method: "POST",
				body: formData
			})
				.then(response => response.text())
				.then(html => {
					// Append the returned HTML to the production list
					const productionList = document.querySelector(".site-archive-production-list");
					productionList.insertAdjacentHTML("beforeend", html);
				})
				.catch(error => console.error("Error loading more productions:", error));
		});

	}

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function (registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
